import React from "react";
import { Link } from "react-router-dom";
import { logoImage } from "../assets/images";
import "./Footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* Red accent bar */}
      <div className="footer-topbar"></div>

      <div className="footer-body">
        <div className="footer-grid">
          {/* Col 1 – Brand */}
          <div className="footer-col footer-col--brand">
            <img
              src={logoImage}
              alt="Fast Track Driving School UK"
              className="footer-logo"
            />
            <p className="footer-tagline">
              Connecting learner drivers with DVSA-approved independent
              instructors across the UK.
            </p>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/groups/1705996953704592/"
                aria-label="Facebook"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/fast_track_driving_school_uk?igsh=MXN4d2xleG03eTVhYQ%3D%3D"
                aria-label="Instagram"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>

            </div>
          </div>

          {/* Col 2 – Learners */}
          <div className="footer-col">
            <h4 className="footer-heading">For Learners</h4>
            <ul className="footer-links">
              <li>
                <Link to="/book-lesson" className="footer-link">
                  Book a Driving Lesson
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer-link">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer-link">
                  Areas We Cover
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer-link">
                  Manual Lessons
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer-link">
                  Automatic Lessons
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer-link">
                  Intensive Courses
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3 – Instructors */}
          <div className="footer-col">
            <h4 className="footer-heading">For Instructors</h4>
            <ul className="footer-links">
              <li>
                <Link to="/become-instructor" className="footer-link">
                  Become an Instructor
                </Link>
              </li>
              <li>
                <Link to="/apply" className="footer-link">
                  Apply Now
                </Link>
              </li>
              <li>
                <Link to="/instructor-terms" className="footer-link">
                  Instructor Terms
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer-link">
                  ADI Requirements
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer-link">
                  Referral Scheme
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4 – Contact */}
          <div className="footer-col">
            <h4 className="footer-heading">Get in Touch</h4>
            <div className="footer-contact-items">
              <div className="footer-contact-item">
                <span className="footer-contact-icon">✉</span>
                <a
                  href="mailto:contact@fasttrackds.co.uk"
                  className="footer-link"
                >
                  contact@fasttrackds.co.uk
                </a>
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <circle cx="12" cy="13" r="8"></circle>
                    <line x1="12" y1="13" x2="12" y2="9"></line>
                    <line x1="12" y1="13" x2="16" y2="13"></line>
                    <path d="M5 5l2 2"></path>
                    <path d="M19 5l-2 2"></path>
                  </svg>
                </span>
                <span className="footer-contact-text">Mon–Sat: 9am – 6pm</span>
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-icon">🇬🇧</span>
                <span className="footer-contact-text">UK-Wide Coverage</span>
              </div>
            </div>
            <div className="footer-badges">
              <span className="dvsa-badge">DVSA Approved</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p>
            &copy; {currentYear} Fast Track Driving School UK. All rights
            reserved.
          </p>
          <div className="footer-legal-links">
            <Link to="/privacy" className="footer-link-small">
              Privacy Policy
            </Link>
            <Link to="/terms" className="footer-link-small">
              Terms & Conditions
            </Link>
            <Link to="/contact" className="footer-link-small">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
